import { icons } from './js/common/icons';
import { FirstRoute, ScrollTo, Visited } from './js/common/keys';
import { log } from './js/common/log';
import { logo } from './js/common/logo';
import { startViewsLoad } from './js/common/views';
import { wire } from './js/common/wire';
import { config } from './js/app/utils/router';
import { render } from './js/common/page';
import { o } from './js/common/observable';
import { r } from './js/common/router';
import { $el, appShadowRoot } from './js/common/elements';
import { load as loadGainsight } from './js/common/gainsight';
import { loadCSS, loadScript } from './utils/loader';

// import deps from legacy app

import './libs/loadicons';
import './libs/coveo-bar';

import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'


const options = {
  "info": {
    "applicationID": import.meta.env.VITE_RELIC_APPLICATION_ID,
    "beacon": "bam.nr-data.net",
    "errorBeacon": "bam.nr-data.net",
    "licenseKey": import.meta.env.VITE_RELIC_LICENSE_KEY,
    "sa": 1
  },
  "init": {
    "ajax": {
      "deny_list": [
        "bam.nr-data.net"
      ]
    },
    "browser_consent_mode": {
      "enabled": false
    },
    "distributed_tracing": {
      "enabled": true
    },
    "performance": {
      "capture_detail": false,
      "capture_marks": false,
      "capture_measures": true
    },
    "privacy": {
      "cookies_enabled": true
    }
  },
  "loader_config": {
    "accountID": import.meta.env.VITE_ACCOUNT_ID,
    "agentID": import.meta.env.VITE_AGENT_ID,
    "applicationID": import.meta.env.VITE_RELIC_APPLICATION_ID,
    "licenseKey": import.meta.env.VITE_RELIC_LICENSE_KEY,
    "trustKey": import.meta.env.VITE_TRUST_KEY
  }
}

// The agent loader code executes immediately on instantiation.
const nrba = new BrowserAgent(options);

// eslint-disable-next-line import/no-unresolved
const indexCssModule = import('./index.scss?inline');


class ExlSupport extends HTMLElement {
  connectedCallback() {
    // import the CSS into the shadow DOM for CSS encapsulation
    indexCssModule.then((mod) => {
      const style = document.createElement('style');
      style.innerHTML = mod.default;
      this.shadowRoot?.append(style);
      // Show the app
      $el.app.removeAttribute('style');
      loadCSS(
        'https://static.cloud.coveo.com/searchui/v2.10081/css/CoveoFullSearch.min.css',
        undefined,
        this.shadowRoot,
      );
    });
  }
}
window.customElements.define('exl-support', ExlSupport);

const SUPPORT_VIEW_NAMES = [
  'admin-form',
  'cxi-case-form',
  'offline-form',
  'recommendation-modal',
  'support-attachment-item',
  'support-attachment-link-item',
  'support-attachment-image-item',
  'support-attachment-loader',
  'support-attachments-item',
  'support-attachments-file',
  'support-case-action',
  'support-case-assit-empty',
  'support-case-assit-view',
  'support-case-detail',
  'support-case-watchers',
  'support-comments-item',
  'support-fieldpicker-item',
  'support-home',
  'support-insight-detail-modal',
  'support-insight-item',
  'support-insight-resolved-modal',
  'support-insights',
  'support-my-cases',
  'support-redeem-code',
  'support-open-ticket',
  'support-orglist-item',
  'support-pagination',
  'support-pagination-item',
  'support-products-item',
  'support-reasons-item',
  'support-resources',
  'support-table-row',
  'support-watcher-item',
  'support-watcher-list',
  'support-activities',
  'tmobile-account',
  'tmobile-activities',
  'tmobile-activity-detail',
  'tmobile-app-shell',
  'tmobile-dashboard',
  'tmobile-deliverables',
  'tmobile-insights',
  'tmobile-kbo-detail',
  'tmobile-learning-partner',
  'tmobile-learning',
  'tmobile-product-resources',
  'tmobile-requests',
  'tmobile-updates-product-detail',
  'tmobile-updates',
];

async function init() {
  // Load dependencies
  const results = await Promise.allSettled([
    loadScript('https://static.cloud.coveo.com/searchui/v2.5395/js/CoveoJsSearch.Lazy.min.js'),
    loadScript('https://static.cloud.coveo.com/searchui/v2.10081/js/CoveoJsSearch.Lazy.min.js'),
  ]);


  try {
    // Log any failed resources
  results.forEach((result, index) => {
    if (result.status === 'rejected') {
      const resources = [
        'zeon-client.js',
        'zeon-client.css',
        'CoveoJsSearch v2.5395',
        'CoveoJsSearch v2.10081',
      ];
      log(`Warning: Failed to load ${resources[index]}`, result.reason);
    }
  });

  try {
    await loadScript('https://static.cloud.coveo.com/searchui/v2.10081/js/templates/templates.js');
  } catch (error) {
    log('Warning: Failed to load Coveo templates', error);
  }
  } catch (error) {
    log('Warning: Failed to load Coveo templates', error);
  }
  localStorage.setItem(Visited, parseInt(localStorage.getItem(Visited) || '0', 10) + 1);

  log(logo, { ts: false });
  log('Starting application');
  icons();

  startViewsLoad(SUPPORT_VIEW_NAMES);
  loadGainsight();
  wire(config);

  o.once(ScrollTo, (id) => {
    const lid = [...r.history[r.history.length - 1].hash.split('/'), id].join(' #');
    const lel = appShadowRoot.querySelector(`#${lid}`);

    if (lel !== null) {
      render(() => lel.scrollIntoView(true));
      log(`Set render frame handler to scroll to element: #${lid}`);
    }
  });

  if (sessionStorage.getItem(FirstRoute) === null) {
    const h = window.location.hash.replace('#', '');

    if (h.length > 0 && h.startsWith('from_ims=true') === false) {
      log('Storing starting route in session');
      sessionStorage.setItem(FirstRoute, h);
    }
  }
}

init();
